import { Tool } from './Tool';

export class EraserTool extends Tool {
  public title = 'TOOLBAR_ERASER';

  public icon = 'icon-eraser1';
}

export const eraserTool = new EraserTool();
